module.exports = function audienceTargetingContext(request, context) {
  return {
    DEVICE_TYPE: context.deviceInformation.type || "unknown",
  };
};
